import { FC, SVGProps } from 'react'

interface Props {
  size?: number
  fill?: string
  className?: string
}

export const ReportSpamIcon: FC<Props> = ({
  size = 24,
  fill = 'white',
  className,
}) => (
  <svg
    width={className ? undefined : size}
    height={className ? undefined : size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <g>
      <path
        d="M12 4C7.85786 4 4.5 7.2351 4.5 11.2258C4.5 14.4991 6.75912 17.2641 9.85714 18.1524C10.5361 18.3471 11.0336 20 12 20C12.9664 20 13.4639 18.3471 14.1429 18.1524C17.2409 17.2641 19.5 14.4991 19.5 11.2258C19.5 7.2351 16.1421 4 12 4Z"
        stroke={fill}
      />
      <path
        d="M12 8V12"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="14.25" r="0.75" fill={fill} />
    </g>
  </svg>
)
